export const FeatureFlags = {
  last_inspection: 'last_inspection',
  address_suggestions_dadata: 'address_suggestions_dadata',
  yandex_metrika: 'yandex_metrika',
  yandex_metrika_webvisor: 'yandex_metrika_webvisor',
  simplified_registration: 'simplified_registration',
  new_form_of_tinkoff_balance_replenishment:
    'new_form_of_tinkoff_balance_replenishment',
  driver_occupations: 'driver_occupations',
  document_based_registration: 'document_based_registration',
  quantity_rental_payments: 'quantity_rental_payments',
  add_email_drawer: 'add_email_drawer',
  visibility_all_balances: 'visibility_all_balances',
  debt_early_repayment: 'debt_early_repayment',
} as const

export type FeatureFlagsEnum = keyof typeof FeatureFlags
